import React, { ChangeEvent, useEffect, useState } from 'react';
import AlcoholItem from '../components/AlcoholItem';
import { AlcoholSortableKeys } from '../constants/AlcoholSortableKeys';
import { AlcoholTranslateMap } from '../constants/AlcoholTranslateMap';
import { TextDomain } from '../constants/TextDomain';
import { Alcohol } from '../models/Alcohol';
import { getItems } from '../utils/api';
import './App.css';
const { __ } = window.wp.i18n;

function App() {
    const [items, setItems] = useState<Alcohol[]>([]);
    const [sortedItems, setSortedItems] = useState<Alcohol[]>([]);
    const [sortBy, setSortBy] = useState<keyof Alcohol>('name');
    const [order, setOrder] = useState<'asc' | 'desc'>('asc');
    const [filterBy, setFilterBy] = useState<keyof Alcohol | 'all' | 'other'>('all');

    useEffect(() => {
        getItems('alcohol', 'asc').then((items) => {
            setItems(items);
        });
    }, [setItems]);

    useEffect(() => {
        let newItems = [...items];
        if (sortBy === 'name') {
            newItems = newItems.sort((a, b) => Intl.Collator().compare(a[sortBy]!.toLowerCase(), b[sortBy]!.toLowerCase()));
        } else {
            newItems = newItems.sort((a, b) => (a[sortBy]! < b[sortBy]! ? -1 : 1));
        }

        if (order === 'desc') {
            newItems = newItems.reverse();
        }

        if (filterBy !== 'all') {
            if (filterBy === 'other') {
                newItems = newItems.filter((e) => e.brand === null);
            } else {
                newItems = newItems.filter((e) => e.brand === filterBy);
            }
        }

        setSortedItems(newItems);
    }, [order, sortBy, filterBy, items]);

    const handleFilterByChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setFilterBy(event.target.value as keyof Alcohol);
    };

    const handleSortByChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setSortBy(event.target.value as keyof Alcohol);
    };

    const handleOrderChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setOrder(event.target.value as 'asc' | 'desc');
    };

    const nonNullBrandItems = Array.from(new Set(items.filter((e) => e.brand !== null).map((e) => e.brand)));
    const nullBrandItemsExist = items.some((e) => e.brand === null);

    if (items.length === 0) {
        return null;
    }

    return (
        <div className="nutrition_values_app">
            <div className="filter_wrapper">
                <div className="filter_label">{__('Order by:', TextDomain)}</div>
                <div className="filter_selects">
                    <select value={sortBy as string} onChange={handleSortByChange}>
                        {AlcoholSortableKeys.map((key) => (
                            <option key={key} value={key}>
                                {__(AlcoholTranslateMap[key], TextDomain)}
                            </option>
                        ))}
                    </select>
                    <select value={order} onChange={handleOrderChange}>
                        <option value="asc">{__('Ascending', TextDomain)}</option>
                        <option value="desc">{__('Descending', TextDomain)}</option>
                    </select>
                    <select value={filterBy as string} onChange={handleFilterByChange}>
                        <option key="all" value="all">
                            {__('All brands', TextDomain)}
                        </option>
                        {nonNullBrandItems.map((key) => (
                            <option key={key} value={key === null ? '' : key}>
                                {key}
                            </option>
                        ))}
                        <option key="other" value="other" hidden={!nullBrandItemsExist}>
                            {__('Other', TextDomain)}
                        </option>
                    </select>
                </div>
            </div>
            <div className="grid-container nutrition_values_wrap">
                {sortedItems.map((item, index) => (
                    <div className="grid-item" key={index}>
                        <AlcoholItem item={item} />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default App;
